module.exports = __webpack_public_path__ + "static/img/腺病毒包装banner.4040d6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/two_Banner/腺病毒包装banner.jpg
// module id = gYGT
// module chunks = 1